<div class="wrapper flex flex-col">
  <div class="heading text-type-1 mb-[20px]">
    Upload activity ids
  </div>
  <div class="template-section text-type-10 mb-[12px]">
    Use this <span (click)="getTemplate()" class="clickable">template</span> to
    upload activity ids
  </div>
  <div class="file-upload-section">
    @if (file) {
      <div
        class="file-name flex flex-row justify-start items-center gap-[5px] mb-[12px] italic">
        <span class="underline underline-offset-4">{{ file.name }}</span>
        <mat-icon (click)="removeSelectedFile()" class="close-icon mt-[5px]">close</mat-icon>
      </div>
    }
    <div class="thumbnail-action-section flex flex-row gap-[1rem]">
      <button
        (click)="openFile('fileUploadRef')"
        class="upload-btn"
        color="primary"
        mat-stroked-button
        >
        Upload
      </button>
      <input
        #fileUploadRef
        (change)="handleFileUpload()"
        [id]="'fileUploadRef'"
        class="input-files"
        type="file"
        />
    </div>

  </div>
  <div class="actions mt-[calc(100px-1.25em)]">
    <app-primary-button
      (handleClick)="onSubmit()"
      [isDisabled]="!form.dirty"
      >
      Submit
    </app-primary-button>
  </div>
</div>
